import { creditCardBrands } from '../constants/companies';

export const skillLevelIconSource = {
  1: require('../images/skill-levels/skill-level-0.png'),
  2: require('../images/skill-levels/skill-level-1.png'),
  3: require('../images/skill-levels/skill-level-2.png')
};

export const categoriesIconSource = {
  2: require('./job-categories/serving.png'),
  3: require('./job-categories/cleaning.png'),
  4: require('./job-categories/cooking.png'),
  20: require('./job-categories/event_staff_emp.png'),
  22: require('./job-categories/serving.png'),
  25: require('./job-categories/event_staff_emp.png')
};

export const creditCardIconSource = {
  [creditCardBrands.visa]: require('./credit-cards/visa.png'),
  [creditCardBrands.mastercard]: require('./credit-cards/mastercard.png'),
  [creditCardBrands.jcb]: require('./credit-cards/jcb.png'),
  [creditCardBrands.unionpay]: require('./credit-cards/unionpay.png'),
  [creditCardBrands.discover]: require('./credit-cards/discover.png'),
  [creditCardBrands['diners club']]: require('./credit-cards/diners.png'),
  [creditCardBrands['american express']]: require('./credit-cards/amex.png')
};



// WEBPACK FOOTER //
// ./src/images/assets.js